import { clsx } from '@alexis/helpers/clsx';
import FlightMissingNoticeBar from '@pages/FlightSearchResult/components/FlightMissingNoticeBar';
import { useFlightSearchResults } from '@pages/FlightSearchResult/contexts/FlightSearchResultsContext';
import React from 'react';

import { useFlightContext } from '@context/FlightContext';

import styles from './ProgressBar.module.scss';

interface ProgressBarProps {
  wegoAnalyticsClientId: string | undefined;
  wegoAnalyticsClientSessionId: string | undefined;
}

const ProgressBar = (props: ProgressBarProps): JSX.Element => {
  const { isPollFailingMidway, progressPercent } = useFlightSearchResults();
  const { isFlightSearch2AndNotMulticity } = useFlightContext();

  return (
    <div
      data-testid='progressBar'
      className={clsx(
        styles.container,
        progressPercent === 100 && styles.hidden,
        isFlightSearch2AndNotMulticity && styles.flightSearch2,
      )}
    >
      {isPollFailingMidway ? (
        <FlightMissingNoticeBar {...props} />
      ) : (
        <div
          data-testid='progressBarInner'
          className={clsx(styles.progressBar, progressPercent === 0 && styles.noTransition)}
          style={{ width: `${progressPercent}%` }}
        ></div>
      )}
    </div>
  );
};

export default React.memo(ProgressBar);
